const HOME = '/'

const PATHS = {
  HOME,
}

export default PATHS
